/**
 * Shared install-time capability grant store.
 *
 * NIP v3 grants capabilities to a tile once at install (from its declared
 * `perm` tags), persisted so re-installing a known tile doesn't re-prompt and
 * so a runtime's `onGrantDecision` can resolve the recorded set.
 *
 * Tile Studio's app-level runtime never actually runs installed tiles (real
 * install happens in Ditto's widget page), so the asker simply grants
 * everything the tile declares.
 */

import {
  createGrantStore,
  createStorageGrantBackend,
  type Capability,
} from '@soapbox.pub/nostr-canvas';

const rawBackend = createStorageGrantBackend(localStorage);

export const grantBackend = rawBackend;

export const grantStore = createGrantStore(
  rawBackend,
  (_identifier, declared) => Promise.resolve(declared),
);

export type { Capability };
